import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WsSyncLogsRepository } from '../../domain/repositories/ws-sync-logs.repository';
import { WsSyncLog, WsSyncLogsQuery } from '../../domain/interfaces/ws-sync-log.types';
import { WsSyncApiService } from '../services/ws-sync-api.service';

@Injectable({ providedIn: 'root' })
export class WsSyncLogsRepositoryImpl extends WsSyncLogsRepository {
  private readonly apiService = inject(WsSyncApiService);

  override getLogs(query: WsSyncLogsQuery): Observable<WsSyncLog[]> {
    return this.apiService.getLogs(query);
  }
}

export const WsSyncLogsRepositoryProvider = {
  provide: WsSyncLogsRepository,
  useExisting: WsSyncLogsRepositoryImpl,
};
